import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

function Login() {

  const navigate = useNavigate();
  const API_BASE_URL =
    process.env.REACT_APP_BACKEND_URL ||
    process.env.REACT_APP_API_URL ||
    "https://uniformnx-com.onrender.com";

  const [formData, setFormData] = useState({
    username: "",
    password: ""
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {

    e.preventDefault();

    Swal.fire({
      title: "Logging in...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {

      const res = await axios.post(`${API_BASE_URL}/user/login`, formData);

      if (res.data && res.data.token) {

        localStorage.setItem("token", res.data.token);
        localStorage.setItem("role", res.data.role);
        localStorage.setItem("username", res.data.username);
        localStorage.setItem(
          "permissions",
          JSON.stringify(res.data.permissions || [])
        );

        Swal.fire({
          icon: "success",
          title: "Login Successful",
          text: `Welcome back, ${res.data.username}`,
          timer: 1500,
          showConfirmButton: false
        }).then(() => {

          // Admin + Staff dashboard redirect
          if (res.data.role === "admin" || res.data.role === "staff") {
            navigate("/dashboard");
          } else {
            navigate("/");
          }

        });

      }

    } catch (err) {

      Swal.fire({
        icon: "error",
        title: "Login Failed",
        text:
          err.response?.data?.message ||
          "Invalid Username or Password!",
        confirmButtonColor: "#d33"
      });

    }

  };

  return (

    <div
      style={{
        textAlign: "center",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundImage:
          "url(https://png.pngtree.com/background/20210709/original/pngtree-cartoon-education-training-cram-school-picture-image_917042.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center"
      }}
    >

      <div className="col-11 col-md-5">

        <form
          onSubmit={handleSubmit}
          className="form-control p-5 shadow"
          style={{
            background: "rgba(255,255,255,0.2)",
            backdropFilter: "blur(10px)",
            border: "none"
          }}
        >

          <h2 className="text-white mb-4 fw-bold">
            Admin / Staff Login
          </h2>

          <input
            type="text"
            name="username"
            className="form-control mb-3 text-center mx-auto w-75 py-2"
            placeholder="Username"
            value={formData.username}
            onChange={handleChange}
            required
            autoComplete="off"
          />

          <input
            type="password"
            name="password"
            className="form-control mb-4 text-center mx-auto w-75 py-2"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            required
          />

          <button
            type="submit"
            className="animated-btn btn border-1 w-75 border-light text-light"
          >
            <span>Login</span>
          </button>

          <div className="text-center mt-3">
            <Link
              to="/forgetpas"
              className="text-white text-decoration-none small opacity-75"
            >
              Forgot Password?
            </Link>
          </div>

        </form>

      </div>

      <style>{`

        .animated-btn{
          position:relative;
          overflow:hidden;
          transition:all 0.4s ease;
          border:1px solid white !important;
          background:transparent;
        }

        .animated-btn span{
          position:relative;
          z-index:2;
          transition:0.4s;
          color:white;
        }

        .animated-btn::before{
          content:"";
          position:absolute;
          top:0;
          left:0;
          width:0%;
          height:100%;
          background:#edf9e5;
          transition:all 0.6s ease;
          z-index:1;
        }

        .animated-btn:hover::before{
          width:100%;
        }

        .animated-btn:hover span{
          color:black !important;
        }

        .animated-btn:hover{
          transform:translateY(-3px);
          box-shadow:0 10px 20px rgba(0,0,0,0.3);
        }

      `}</style>

    </div>

  );

}

export default Login;
